<template>
    <b-nav v-if="!isLoading" vertical style="width:100%;" class="menu-component">
        <component v-for="(menuItem, index) in visibleMenuItems"
                   v-bind:is="isSubHeader(menuItem) ? 'b-nav-text' : 'b-nav-item'"
                   :key="index"
                   :to="!isLink(menuItem) ? menuItem.to : undefined" :class="{...menuItem.class, active: isActive(menuItem)}"
                   :href="isLink(menuItem) ? menuItem.to : undefined"
                   :target="menuItem.target ?? ''"
        >
            <strong v-if="isSubHeader(menuItem)" class="menu-header">
              {{ $t(menuItem.title) }}
            </strong>
            <span v-else class="menu-item">
                <i class="metismenu-icon font-size-xlg opacity-5" :class="menuItem.icon"></i>
                <span class="d-inline-block pl-3 align-top">
                  {{ $t(menuItem.title) }}
                </span>
            </span>
        </component>
    </b-nav>
</template>

<script>
import menuStructure from "../config/menu-structure";

export default {
    name: "Menu",

    data() {
        return {
            isLoading: true,
            promises: [],
            menuItems: [],
        }
    },

    mounted() {
        menuStructure.forEach((menuItem, index) => {
            const show = menuItem.show()

            // Support async generating of these values
            if (menuItem.to instanceof Promise) {
                this.promises.push(
                    menuItem.to.then(to => menuItem.to = to)
                )
            }
            if (show instanceof Promise) {
                show.then(s => menuItem.show = () => s)
            }

            this.$set(this.menuItems, index, menuItem)
        })

        Promise.all(this.promises)
            .then(() => this.isLoading = false)
    },

    methods: {
        isSubHeader(menuItem) {
            return (typeof menuItem.to === "undefined")
        },
        isLink(menuItem) {
            return typeof menuItem.to === "string"     &&
                   menuItem.to.indexOf('https')   !==  -1;
        },
        isActive(menuItem) {
            return (
                (menuItem.matchRouteNames && menuItem.matchRouteNames.indexOf(this.$route.matched[0]?.name) !== -1)
                || (menuItem.to?.name === this.$route.matched[0]?.name && menuItem.to?.name)
            )
        },
    },
    computed: {
        visibleMenuItems() {
            return this.menuItems.filter(menuItem => menuItem.show() === true);
        }
    }
}
</script>

<style lang="scss">
.menu-component {
    .menu-header {
        font-size: 13px;
        color: #0007;
        text-transform: uppercase;
    }

    .menu-item {
        font-size: 14px;
        color: #000;

        i {
            display: inline-block;
            width: 20px;
            text-align: center;
        }

        > span {
            width: calc(100% - 20px);
        }
    }

    li.nav-item {
        border-radius: 5px;

        a {
            padding-bottom: 2px;
        }

        &:hover,
        &.active {
            background: #333;

            i, span {
                color: hsla(0, 0%, 100%, 1) !important;
            }
        }
    }
}
</style>
